<template>

<div class="map-component" :id="mapId">

</div>


<!--        <div v-for="(item, index) in this.OfferLocs" :key="index">-->
<!--            <div class="item"-->
<!--            >-->
<!--                <span class="itemText">  {{item.Latitude || ''}} </span>-->

<!--            </div>-->
<!--        </div>-->


</template>

<script>

    export default {
        name: "MapComponent",
        props: ['offerLocations', 'mapCenter', 'mapId', 'zoomSetting', 'dontShowText', 'dontShowInfoWindow'],
        data() {
            return {
            map: null,
            user: null,
            mapCenterLocation: null,
            defaultCenter: {lat: 37.0902, lng: 95.7129},

         }
        },
        methods: {

            initMap(center, mapId) {
                this.map = new google.maps.Map(document.getElementById(mapId), {
                    center: center,
                    //this.mapCenterLocation,
                    zoom: this.zoomSetting ? this.zoomSetting : 10,
                    maxZoom:20,
                    minZoom:0,
                    streetViewControl: true,
                    mapTypeControl: true,
                    fullscreenControl: true,
                    zoomControl: true,
                    previousWindow: false,
                    // mapTypeId: google.maps.MapTypeId.ROADMAP
                });

                // google.maps.event.addListener(this.map, 'center_changed', () => {
                //     alert(this.map.getCenter());
                // });

                // let mp = this.map;
                // google.maps.event.addListener(this.map, 'dragstart', () => {
                //     // document.getElementById("start").value = this.map.getCenter();
                //    console.log(this.map.getCenter());
                // });
                // //
                // google.maps.event.addListener(this.map, 'dragend', () => {
                //     // document.getElementById("end").value = this.map.getCenter();
                //     console.log(this.map.getCenter());
                // });

                // google.maps.event.addListener(this.map, 'mousemove', function(event) {
                //     console.log(event.latLng.toString());
                // });

                // console.log(this.map);

            },
            setMarker(Points, merchant) {

                let mk = {
                    position: Points,
                    map: this.map,
                };

                if(this.dontShowText) {

                } else {
                    mk.label = {
                        text: merchant.OfferNumber ? String(merchant.OfferNumber) : '',
                        color: "#FFF"
                    }
                }

                const marker = new google.maps.Marker(mk);

                if(this.dontShowInfoWindow) {

                }  else {
                    const infowindow = new google.maps.InfoWindow({
                        content: '<div class="p-3"><p>' + merchant.Category + '<p>' + // Category
                            '<p style="font-weight: bold">' + merchant.MerchantName + '</p>' + // Merchant Name
                            '<p style="font-weight: bold">'  + merchant.Headline + '</p>' + // Headline
                            '<p>' + merchant.Street + '</p>' + // Address
                            '<a href="javascript:;" id="learn_more_' + merchant.offerId + '" class="tile-cursor txt-black-imp">Learn more <img style="height: 0.5vw" src="../images/arrowright.svg"> </a></div>'
                    });


                    let eventHub = this.$eventHub;

                    google.maps.event.addListener(infowindow, 'domready', () => {
                        document.getElementById('learn_more_' + merchant.offerId).addEventListener("click", showOfferDetailsModal);

                        function showOfferDetailsModal() {
                            eventHub.$emit('emit_from_map_' + merchant.offerId, merchant.offerId);
                        }
                    });


                    marker.addListener("click", () => {
                        if (this.previousWindow) {
                            this.previousWindow.close();
                        }
                        infowindow.open({
                            anchor: marker,
                            map: this.map,
                            shouldFocus: false,
                        });

                        this.previousWindow = infowindow;
                    });
                }

            }
        },
        mounted() {
            /**
             * if map center is being passed as prop, respecy it.
             * fall back to user zip code if not passed
             */
          //  console.log(this.mapCenter, 'cent');
            if(this.mapCenter && this.mapCenter.latitude && this.mapCenter.longitude) {
                this.mapCenterLocation =  {lat:parseFloat(this.mapCenter.latitude), lng:parseFloat(this.mapCenter.longitude)};

                this.initMap(this.mapCenterLocation, this.mapId);
            } else if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));

                if(this.user.location) {

                    this.mapCenterLocation =  {lat:parseFloat(this.user.location.latitude), lng:parseFloat(this.user.location.longitude)};

                    this.initMap(this.mapCenterLocation, this.mapId); // start with user location as default center
                }
            } else {
                this.initMap(this.defaultCenter, this.mapId);
            }

            if(this.offerLocations && this.offerLocations.length) {
                this.offerLocations.map(x => {
                    this.setMarker({lat: parseFloat(x.Latitude), lng: parseFloat(x.Longitude)}, x);
                });
            }
        },
        computed: {

        },
        watch: {

            offerLocations: function (val) {
                if(this.mapCenter && this.mapCenter.longitude && this.mapCenter.latitude) {
                    this.initMap( {lat:parseFloat(this.mapCenter.latitude), lng:parseFloat(this.mapCenter.longitude)}, this.mapId);
                } else {
                    this.initMap(this.defaultCenter, this.mapId);
                }

                val.map(x => {
                    this.setMarker({lat: x.Latitude ,lng:x.Longitude}, x);
                });
            }
        }
    }
</script>

<style scoped>
    .map-component {
        /*position: fixed !important;*/
        height: 100% !important;
        width: 100% !important;
    }

    @media screen and (max-width : 992px) {
        .map-component {
            min-height: 280px;
        }
	}
</style>
